









































































































































































































































import { AxiosError } from 'axios';
import _ from 'lodash';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

import { Size } from '@/enums';
import { marketShareOperationType } from '@/modules/dap/enums';
import { IProject, ISaleTarget, ISubProject } from '@/modules/dap/interfaces';
import { Project, SubProject } from '@/modules/dap/models';
import { dateService, httpService, numeralService } from '@/services';

import { CONFIG } from '@/config';

@Component
export default class DapProjectInfoPanel extends Vue {
  @Prop({ default: false }) open: boolean;
  @Prop({ required: true }) projectId: number;
  @Prop({ required: true }) dapId: number;

  public parseToMoment = dateService.parseToMoment;
  public Size = Size;
  public parseDateToString = dateService.parseDateToString;
  public parseStringToDate = dateService.parseStringToDate;
  public parseNumberToString = numeralService.parseNumberToString;
  public marketShareOperationType = marketShareOperationType;

  public productsType = {};
  public segmentsType = {};
  public referenceMktShareType: any[] = [];
  public marketLevelDataSource = [];
  public productsDataSource = [];
  public segmentsDataSource = [];
  public project: IProject = new Project();
  public subProject: ISubProject = new SubProject();

  public get saleTargetsView () {
    return _(this.saleTargets)
      .chunk(6)
      .value();
  }

  public get saleTargets () {
    return this.subProject.saleTargets.length > 0
      ? this.subProject.saleTargets
      : _.map(_.range(0, this.project.qtdMonths), (i: number) => ({
        value: 0,
        monthReference: i + 1
      }));
  }

  public get segmentsInfluenceGroup () {
    if (this.subProject.subProjectLimits && this.subProject.subProjectLimits[0] && (this.subProject.subProjectLimits[0] as any).cfgMtdSegmentInfluencesDto.length) {
      return _.chunk((this.subProject.subProjectLimits[0] as any).cfgMtdSegmentInfluencesDto, 6);
    }
    return [];
  }

  public getSaleTargets (monthNumber: number): ISaleTarget | undefined {
    return _.find(this.subProject.saleTargets, (item: ISaleTarget) => item.monthNumber === monthNumber);
  }

  @Emit('close')
  onClose () {} // tslint:disable-line

  public createSubProjectLimits () {
    this.subProject.subProjectLimits = _(this.marketLevelDataSource)
      .filter((d: any) => d.idType === this.subProject.idMarketShareReferenceType)
      .map((d: any) => _.assign({}, d, {
        name: d.name
      }, ((_.find(this.subProject.subProjectLimits, (ml: any) => ml.idMarketShareReference === d.idType) as any) || {})))
      .value();
  }

  public createSaleTargets () {
    this.subProject.saleTargets = _(this.saleTargets)
      .map((d: any, i: number) => ({
        value: d.value,
        monthNumber: i + 1,
        monthReference: Number(dateService.parseToMoment(this.subProject.initialDateProject).add(i, 'months').format('MM')),
        monthName: dateService.parseToMoment(this.subProject.initialDateProject).add(i, 'months').format('MMM'),
        yearReference: Number(dateService.parseToMoment(this.subProject.initialDateProject).add(i, 'months').format('YYYY')),
        shortYear: Number(dateService.parseToMoment(this.subProject.initialDateProject).add(i, 'months').format('YY'))
      }))
      .value();
  }

  @Watch('dapId')
  public loadParameters () {
    if (this.dapId === 0) {
      return;
    }

    const req = [
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/families`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/segments`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/mktShareReferenceTypes`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/info`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${this.dapId}/config`)
    ];

    Promise.all(req)
      .then((res: any) => {
        this.productsType = res[0].data.reduce((acc: any, val: any) => {
          acc[val.value] = val.text;
          return acc;
        }, {});

        this.segmentsType = res[1].data.reduce((acc: any, val: any) => {
          acc[val.value] = val.text;
          return acc;
        }, {});

        this.project = res[3].data;
        this.productsDataSource = res[0].data;
        this.segmentsDataSource = res[1].data;
        this.referenceMktShareType = _.map(res[2].data, (d: any) => ({ text: d.name, value: d.id }));
        this.marketLevelDataSource = _.reduce(res[2].data, (acc, val) => acc.concat(val.marketShareRefences), []);

        this.subProject = { ...this.subProject, ...res[4].data };
        this.subProject.idProject = this.project.id;
        this.subProject.idMarketShareReferenceType = this.project.idMarketShareReferenceType as any;
        this.subProject.initialDateProject = new Date(this.project.initialDateProject);
        this.subProject.initialHistoryPeriod = this.subProject.initialHistoryPeriod ? new Date(this.subProject.initialHistoryPeriod) : new Date(this.project.initialHistoryPeriod);
        this.subProject.finalHistoryPeriod = this.subProject.finalHistoryPeriod ? new Date(this.subProject.finalHistoryPeriod) : new Date(this.project.finalHistoryPeriod);

        this.createSubProjectLimits();
        this.createSaleTargets();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  created () {
    this.loadParameters();
  }
}
